export default __webpack_public_path__ + "static/media/imgpost6.d63fa59e.jpg";